import { observable, action, computed } from 'mobx'
import {toJS} from 'mobx';
import moment from 'moment';
import 'moment/locale/pt-br';
import CompanyService from 'services/CompanyService'
import NotificationStore from 'stores/NotificationStore';
import { SiteProviderStore } from '../site/SiteProviderStore';
import { Navigator } from 'router/index'
import { persist, create } from 'mobx-persist';

class CompanyTag {
  constructor(json = {}) {
    this.pk_company_tag = json.pk_company_tag
    this.color = json.color
    this.name = json.name
  }
}

class User {

  @observable password
  @observable confirmPassword
  @observable name
  @observable photo
  @observable newPassword
  @observable confirmNewPassword
  @observable account_token

  /* Personal Data */
  @observable email
  @observable name
  @observable personal_phone
  @observable birthday
  @observable cpf
  @observable rg
  @observable issuer
  @observable issue_date

  /* Enterprise Data */
  @observable cep
  @observable city
  @observable state
  @observable address
  @observable district
  @observable number
  @observable fantasy_name
  @observable social_reason
  @observable business_phone
  @observable description
  @observable cnpj
  @observable bank_number
  @observable agency_number
  @observable account_number

  /* Bank Data */
  @observable owner
  @observable document
  @observable bank_number
  @observable agency_number
  @observable agency_check_number
  @observable account_number
  @observable account_check_number

  /* My Site Data */
  @observable my_site_logo
  @observable banner
  @observable image
  @observable my_site_address_contact_mail
  @observable my_site_address_contact_phone
  @observable my_site_address_contact_cel
  @observable my_site_address_contact_address
  @observable my_site_social_network_facebook
  @observable my_site_social_network_instagram
  @observable my_site_social_network_twitter
  @observable my_site_theme_color
  @observable my_site_metrics
  @observable categories = []
  @observable types = []
  @observable fk_region
  @observable region_url

  constructor(json = {}) {
    this.pk_company = json.pk_company || null;
    this.password = json.password || "";
    this.reset_password = json.reset_password || 0;
    this.auth_key = json.auth_key || "";
    this.photo = json.photo || "";
    this.account_token = json.account_token || null

    /* Personal Data */
    this.email = json.email || "";
    this.name = json.name || ''
    this.birthday = json.birthday || ''
    this.personal_phone = json.personal_phone || ''
    this.cpf = json.cpf || ''
    this.rg = json.rg || ''
    this.issuer = json.issuer || ''
    this.issue_date = json.issue_date || ''
    this.enrollment = json.enrollment || ''

    /* Enterprise Data */
    this.social_reason = json.social_reason || ''
    this.business_phone = json.business_phone || ''
    this.cep = json.cep || ''
    this.city = json.city || ''
    this.state = json.state || ''
    this.address = json.address || ''
    this.district = json.district || ''
    this.number = json.number || ''
    this.fantasy_name = json.fantasy_name || ''
    this.description = json.description || ''
    this.cnpj = json.cnpj || ''
    this.categories = Array.isArray(json.categories) ? json.categories : []
    this.types = Array.isArray(json.types) ? json.categories : []
    this.fk_region = json.fk_region || undefined

    /* Bank Data */
    this.owner = json.owner || ''
    this.document = json.document || ''
    this.bank_number = json.bank_number || ''
    this.agency_number = json.agency_number || ''
    this.agency_check_number = json.agency_check_number || ''
    this.account_number = json.account_number || ''
    this.account_check_number = json.account_check_number || ''


    this.password = ''
    this.newPassword = ''
    this.confirmNewPassword = ''
    this.confirmPassword = ''

     /* My Site Data */
    this.my_site_logo = json.my_site_logo || ''
    this.my_site_address_contact_mail = json.my_site_address_contact_mail || ''
    this.my_site_address_contact_phone = json.my_site_address_contact_phone || ''
    this.my_site_address_contact_cel = json.my_site_address_contact_cel || ''
    this.my_site_address_contact_address = json.my_site_address_contact_address || ''
    this.my_site_social_network_facebook = json.my_site_social_network_facebook || ''
    this.my_site_social_network_instagram = json.my_site_social_network_instagram || ''
    this.my_site_social_network_twitter = json.my_site_social_network_twitter || ''
    this.my_site_theme_color = json.my_site_theme_color || ''
    this.my_site_metrics = json.company_metrics || []
    this.banner = json.banner || {}
    this.image = json.image || {}

    SiteProviderStore.loadSiteInfo(json);
  }

}

class AuthStoreClass {

  @persist('object') @observable user = {}
  @observable newUser = {}
  @observable tags;

  @observable errorForgotPassword = false;
  @observable errorNewPassword = false;
  @observable isLoading;
  @observable updatingAttributes;
  @observable isLogged;
  @observable isLoginValid;
  @observable loadingUploadingImagesProgress;
  @observable loadingUploadingImages = false;

  constructor() {
    this.isLogged = false;
    this.isLoading = false;
    this.updatingAttributes = false;
    this.isLoginValid = true;
    this.user = new User(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {});
    this.newUser = new User();
    this.tags = [];
  }

  @computed
  get readyToCreateAccount(){
    return !!(this.newUser.name &&
           this.newUser.email &&
           this.newUser.password &&
           this.newUser.confirmPassword)
  }

  @computed
  get personalDataComplete(){
    return !!this.user.name &&
           !!this.user.personal_phone &&
           !!this.user.birthday &&
           !!this.user.cpf
  }

  @computed
  get businessDataComplete(){
    return !!this.user.fantasy_name &&
           !!this.user.business_phone &&
           !!this.user.social_reason &&
           !!this.user.cnpj &&
           !!this.user.address &&
           !!this.user.number &&
           !!this.user.state &&
           !!this.user.city &&
           !!this.user.cep
  }

  @computed
  get bankDataComplete(){
    return !!this.user.bank_number &&
           !!this.user.agency_number &&
           !!this.user.account_number &&
           !!this.user.account_check_number && 
           !!this.user.owner &&
           !!this.user.document
  }

  @computed
  get companyInformationReady(){
    return this.bankDataComplete &&
           this.personalDataComplete &&
           this.businessDataComplete
  }

  setUser(params) {
    this.isLogged = true;
    this.isLoginValid = true;
    this.user = new User(params);
    localStorage.setItem("user", JSON.stringify(this.user));
    return true
  }

  @action
  logout() {
    this.user = {}
    localStorage.clear();
  }

  @action
  login(redirect = '/dashboard') {
    this.isLoading = true;
    return CompanyService.loginUser({ ...this.user })
      .then(result => {
        this.isLoading = false;
        this.setUser(result.data)

        if (this.user.reset_password === 1) {
          Navigator.replace('/reset-password');
        } else if (this.user.enrollment === 'ACCOUNT_CREATED') {
          Navigator.replace('/onboarding/create-profile')
        } else {
          Navigator.replace(redirect);
        }

        return true
      })
      .catch(error => {
        this.isLoading = false;
        this.isLoginValid = false;

        return false
      });
  }


  @action
  forgotPassword() {
    this.isLoading = true;
    return CompanyService.forgotPassword({ ...this.user }).then(() => {
      this.errorForgotPassword = false;
      this.isLoading = false;
      NotificationStore.setNotification("Uma nova senha foi enviada ao seu e-mail");
      Navigator.replace('/login');
    }).catch(() => {
      this.errorForgotPassword = true;
      this.isLoading = false;
    });
  }

  @action
  changePassword() {
    if (this.user.newPassword < 8) {
      this.errorNewPassword = true;
      return false;
    }

    if (this.user.newPassword === this.user.confirmNewPassword) {
      this.isLoading = true;
      CompanyService.changePassword({
        new_password: this.user.newPassword,
      }).then(result => {
        this.isLoading = false;
        Navigator.replace('/dashboard');
      })
        .catch(error => {
          this.isLoading = false;
        });
    }
  }

  @action
  closeForgotPasswordError() {
    this.errorForgotPassword = false;
  }


  @action
  onChangeUser(name, value) {
    this.user[name] = value;
    if (name === "password") {
      this.errorNewPassword = false;
    }
  }

  @action
  toggleUserCategory(fk_category) {
    const category = this.user.categories.find(cat => cat === fk_category)
    if (category) {
      this.user.categories = this.user.categories.filter(cat => cat !== fk_category)
    } else {
      this.user.categories = [...this.user.categories, fk_category]
    }
  } 

  @action
  toggleUserType(fk_company_category_type) {
    const category = this.user.types.find(type => type === fk_company_category_type)
    if (category) {
      this.user.types = this.user.types.filter(type => type !== fk_company_category_type)
    } else {
      this.user.types = [...this.user.types, fk_company_category_type]
    }
  } 

  @action
  onChangeNewUser(name, value) {
    this.newUser[name] = value;
  }

  @action
  createAccount() {
    this.isLoading = true;
    const payload = {
      name: this.newUser.name,
      email: this.newUser.email,
      password: this.newUser.password
    }

    return CompanyService.createAccount(payload).then(res => {
      this.isLoading = false;
      return res;
    }).catch(err => {
      this.isLoading = false;
      throw err;
    })
  }

  @action
  createProfile() {
    this.isLoading = true;
    const payload = {
      fantasyName: this.user.fantasy_name,
      contactEmail: this.user.my_site_address_contact_mail,
      contactPhone: this.user.my_site_address_contact_phone,
      description: this.user.description,
      types: this.user.types ? this.user.types : [],
      categories: this.user.categories ? this.user.categories : [],
      fk_region: this.user.fk_region,
      address: this.user.address,
      district: this.user.district,
      city: this.user.city,
      state: this.user.state,
      number: this.user.number
    }

    return CompanyService.publishAdvertise(payload).then(res => {
      this.isLoading = false;
      this.user.region_url = res.data.region_url ? res.data.region_url : 'brasil'
      return res;
    })
  }

  @action
  validateEmail(token) {
    this.isLoading = true;
    
    return CompanyService.validateEmail({ token }).then(res => {
      if (res.data) {
        this.isLoading = false;
        return this.setUser(res.data)
      }
    })
  }

  @action
  updatePersonalAttributes(params) {
    this.isLoading = true

    return CompanyService.updatePersonalAttributes(params).then(result => {
      this.isLoading = false
      //this.user = new User(result.data);
    })
  }

  @action
  updateBusinessAttributes(params) {
    this.isLoading = true

    return CompanyService.updateBusinessAttributes(params).then(result => {
      this.isLoading = false
      //this.user = new User(result.data);
    })
  }

  @action
  updateBankAttributes(params) {
    this.isLoading = true

    return CompanyService.updateBankAttributes(params).then(result => {
      this.isLoading = false
      //this.user = new User(result.data);
    })
  }

  @action
  updateAttributes() {
    this.updatingAttributes = true

    const personalAttributes = {
      name: this.user.name,
      email: this.user.email,
      cpf: this.user.cpf,
      personal_phone: this.user.personal_phone.replace('(', '').replace(')', ''),
      birthday: moment(this.user.birthday,'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    const businessAttributes = {
      cnpj: this.user.cnpj.replace(/\D/g, ''),
      social_reason: this.user.social_reason,
      fantasy_name: this.user.fantasy_name,
      business_phone: this.user.business_phone.replace('(', '').replace(')', ''),
      address: this.user.address,
      number: this.user.number,
      district: this.user.district,
      city: this.user.city,
      state: this.user.state,
      cep: this.user.cep
    }

    const bankAttributes = {
      bank_number: this.user.bank_number,
      agency_number: this.user.agency_number,
      agency_check_number: this.user.agency_check_number,
      account_number: this.user.account_number,
      account_check_number: this.user.account_check_number,
      owner: this.user.owner,
      document: this.user.document
    }

    return Promise.all([this.updateBankAttributes(bankAttributes), 
                this.updatePersonalAttributes(personalAttributes),
                this.updateBusinessAttributes(businessAttributes)])
    .then(() => CompanyService.enableMoipAccount()).then(() => {
      this.updatingAttributes = false
      return this.user
    })
  }

  @action
  getCompanyTags() {
    this.fetchingCompanyTags = true
    return CompanyService.getCompanyTags()
      .then(res => {
        this.fetchingCompanyTags = false
        this.tags = res.data
      })
      .catch(err => {
        this.fetchingCompanyTags = false
        throw err
      })
  }

  @action
  setCompanyTags(tags) {
    this.tags = tags
  }

  @action
  setBanner(image) {
    this.user.banner = image
  }

  @action
  setImage(image) {
    this.user.image = image
  }

  @action
  uploadImages(){
    this.loadingUploadingImages = true
    this.loadingUploadingImagesProgress = 1;
    return CompanyService.uploadImages({ banner: this.user.banner, image: this.user.image }, prog => this.loadingUploadingImagesProgress = prog)
            .then(res => {
              this.loadingUploadingImages = false
            })
            .catch(err => {
              this.loadingUploadingImages = false
              throw err
            })
  }

  @action
  changeCompanyTags(tags) {
    this.updatingCompanyTags = true

    return CompanyService.changeCompanyTags({ tags: this.tags })
      .then(res => {
        this.updatingCompanyTags = false
        this.tags = res.data.company_tags
      })
      .catch(err => {
        this.updatingCompanyTags = false
        throw err
      })
  }

  @action 
  saveMySiteData(siteProviderStoreData){
    
    let data = toJS(siteProviderStoreData)
    
    this.user.my_site_logo = data.logo
    this.user.my_site_address_contact_mail = data.addressAndContact.mail
    this.user.my_site_address_contact_phone = data.addressAndContact.phone
    this.user.my_site_address_contact_cel = data.addressAndContact.cel
    this.user.my_site_address_contact_address = data.addressAndContact.address
    this.user.my_site_social_network_facebook = data.socialNetwork.facebook
    this.user.my_site_social_network_instagram = data.socialNetwork.instagram
    this.user.my_site_social_network_twitter = data.socialNetwork.twitter
    this.user.my_site_theme_color = data.themeColor
    this.user.my_site_metrics[0] = data.metricOne
    this.user.my_site_metrics[1] = data.metricTwo
    this.user.my_site_metrics[2] = data.metricThree
  }

  @action
  downloadLeads(){
    return CompanyService.downloadLeads();
  }
}

export const AuthStore = new AuthStoreClass();

create({})('AuthStore', AuthStore)


// WEBPACK FOOTER //
// ./src/modules/auth/AuthStore.js